import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { SearchCriteriaService } from './search-criteria.service';

@Component({
    selector: 'search-criteria',
    templateUrl: './search-criteria.html'
})
export class SearchCriteriaComponent implements OnInit {
    @Input() context: number;
    @Input() initialSearch: string;
    @Input() placeholder: string;
    @Output() onResultsReceived = new EventEmitter<any>();
    @Output() onSearchStringChanged = new EventEmitter<string>();
    @Output() onSearchCompleted = new EventEmitter<boolean>();
    @Output() onSearchStringUsed = new EventEmitter<string>();
    public searchString: string;

    constructor(private searchCriteriaService: SearchCriteriaService) {}

    ngOnInit() {
        this.searchString = this.initialSearch ? this.initialSearch : '';
    }

    async search() {
        this.onSearchCompleted.emit(false);
        this.searchString = this.prepareSearchString(this.searchString);

        if (this.searchString !== ''){
	        await this.retrieveSearchResults(this.searchString);
            this.onSearchCompleted.emit(true);
        }
    }

    searchStringChanged(modifiedSearch: string) {
        this.onSearchStringChanged.emit(modifiedSearch);
    }

    private parseCsvForDriversId(searchString: string) {
        let csv: string[];
        csv = searchString.split(',');
        // if there are not at least 10 CSV entries (i.e., not a DL scan), return original string
        let result = csv[9] ? csv[9] : searchString;
        return result;
    }

    private prepareSearchString(searchString: string): string {
        let result = searchString.trim();

        // If character length greater than 50. assume this is a Drivers ID scan
        if (result.length >= 50) {
            result = this.parseCsvForDriversId(result);
        }

        return result;
    }

    private async retrieveSearchResults(searchString: string) {
        let results = await this.searchCriteriaService.search(searchString, this.context).pipe(first()).toPromise();
        this.onSearchStringUsed.emit(searchString);
        this.onResultsReceived.emit(results);

        if (results && results.length) {
            this.searchString = '';
        }
    }
}
